import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from "motion/react";
export function StaggeredFadeLoader({ className = "bg-white/50", size = 4 }) {
    const circleVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };
    const sizeClass = {
        1: "h-1 w-1",
        2: "h-2 w-2",
        3: "h-3 w-3",
        4: "h-4 w-4",
        5: "h-5 w-5",
    }?.[size] || "h-4 w-4";
    return (_jsx("div", { className: `flex items-center justify-center ${size <= 2 ? "space-x-1" : "space-x-2"}`, children: [...Array(3)].map((_, index) => (_jsx(motion.div, { className: `${sizeClass} rounded-full ${className}`, variants: circleVariants, initial: "hidden", animate: "visible", transition: {
                duration: 0.9,
                delay: index * 0.2,
                repeat: Infinity,
                repeatType: "reverse",
            } }, index))) }));
}
